var Validate = function (target, name, descriptor) {
    var fn = descriptor.value;
    descriptor.value = function () {
        var _this = this;
        this.$validator.errors.clear();
        this.$nextTick(function () {
            _this.$validator.validateAll().then(function (isValid) {
                if (isValid) {
                    fn.apply(_this);
                }
            });
        });
    };
    return descriptor;
};
export default Validate;



//////////////////
// WEBPACK FOOTER
// ./src/decorators/validate.ts
// module id = 59
// module chunks = 0